export const helloWorld = () => {
  console.log('Hello, world!')
}
